import { takeLatest } from 'redux-saga/effects';
import { loadBetPosition } from './loadBetPosition';
import {
  CHANGE_OFFER_PRICE,
  RELOAD_BET_POSITION,
  CHANGE_AUCTION_BET,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PLACING_TYPE,
  SELECT_PACKAGE,
  SELECT_PUBLISH_TERMS_SERVICE,
} from '../../reducers';

export function* betPositionSagas() {
  yield takeLatest(
    [
      LOAD_PUBLISH_TERMS_SUCCESS,
      CHANGE_OFFER_PRICE,
      RELOAD_BET_POSITION,
      CHANGE_AUCTION_BET,
      SELECT_PLACING_TYPE,
      SELECT_PACKAGE,
      SELECT_PUBLISH_TERMS_SERVICE,
    ],
    loadBetPosition,
  );
}
